import React from "react";

import UrlIcon from "../icons/call.svg";

const Features = ({actionProvider}) => {
  const options = [
    { text: "Data Science / AI Jobs", handler: actionProvider.handleAttendance, id: 1 },
    { text: "Cyber Security Jobs", handler: actionProvider.handleExams, id: 2 },
    { text: "General IT / Software Roles", handler: actionProvider.handleFees, id: 3 },
    // { text: "✅ Parent-Teacher Communication", handler: actionProvider.handleParentCommunication, id: 4 },
    // { text: "✅ Notifications & Alerts", handler: actionProvider.handleParentCommunication, id: 5 },
    // { text: "✅ Admin Dashboard & Analytics", handler: actionProvider.handleAnalytics, id: 6 },
    // { text: "✅ Book A Demo", handler: actionProvider.handleBookDemo, id: 7 },

  ];
  return (
    <div className="options">
    <p>👉 Which path are you aiming for?</p>
    <div className="options-containerF">
        {options.map((option) => {
          return (
            <div
              className="option-itemF"
              onClick={option.handler}
              key={option.id}
            >
              {option.text}
            </div>
          );
        })}
      </div>
  </div>
  );
};

export default Features;
